export const UPLOAD_FOLDERS = {
  PROFILE_PICTURE: "profile_picture",
  DEVICE: "device",
  MAINTENANCE: "maintenance",
  DEFAULT: "uploads",
};

export const UPLOAD_LIMITS = {
  MAX_FILE_SIZE_MB: 10,
  MAX_FILE_SIZE_BYTES: 10 * 1024 * 1024,
  ALLOWED_IMAGE_TYPES: ["image/jpeg", "image/jpg", "image/png"],
  ALLOWED_IMAGE_EXTENSIONS: [".jpg", ".jpeg", ".png"],
  ALLOWED_IMAGE_ACCEPT: ".jpg,.jpeg,.png",
  ALLOWED_IMAGE_LABEL: "JPG, JPEG, or PNG",
};

export const validateImageFile = (file) => {
  if (!file) {
    return { valid: false, message: "Please select an image file." };
  }

  if (file.size > UPLOAD_LIMITS.MAX_FILE_SIZE_BYTES) {
    return {
      valid: false,
      message: `File size must not exceed ${UPLOAD_LIMITS.MAX_FILE_SIZE_MB} MB.`,
    };
  }

  const fileName = file.name?.toLowerCase() || "";
  const hasAllowedExtension = UPLOAD_LIMITS.ALLOWED_IMAGE_EXTENSIONS.some(
    (ext) => fileName.endsWith(ext),
  );

  if (
    !UPLOAD_LIMITS.ALLOWED_IMAGE_TYPES.includes(file.type) &&
    !hasAllowedExtension
  ) {
    return {
      valid: false,
      message: `Only ${UPLOAD_LIMITS.ALLOWED_IMAGE_LABEL} images are allowed.`,
    };
  }

  return { valid: true, message: "" };
};

export const getUploadedFileKey = (uploadResult) => {
  if (!uploadResult) return "";
  if (Array.isArray(uploadResult)) {
    return uploadResult[0]?.fileKey || uploadResult[0]?.filename || "";
  }
  return uploadResult?.fileKey || uploadResult?.filename || "";
};

export const getUploadedFileKeys = (uploadResult) => {
  if (!uploadResult) return [];
  if (Array.isArray(uploadResult)) {
    return uploadResult.map((item) => item?.fileKey || item?.filename || "");
  }
  return [uploadResult?.fileKey || uploadResult?.filename || ""];
};

export const partitionFilesForUpload = (files) => {
  const filesToUpload = [];
  const existingFiles = [];

  if (!Array.isArray(files)) {
    return { filesToUpload, existingFiles, hasFileChanges: files === null };
  }

  files.forEach((file) => {
    if (file instanceof File) {
      filesToUpload.push(file);
    } else if (typeof file === "string" && file.trim()) {
      existingFiles.push(file);
    }
  });

  return { filesToUpload, existingFiles, hasFileChanges: true };
};
